import UseWebservice from "../../util/UseWebservice";
import IFormService from "./IFormService";
import MockFormService from "./MockFormService";
import WebFormService from "./WebFormService";

export default class FormServiceFactory {
    public static getFormService(): IFormService {
        if(!UseWebservice()) {
            return new MockFormService();
        }
        
        return new WebFormService();
    }
}